<template>
  <div class="config-content-box">
    <div class="config-title">{{ccSchemaName}}</div>
    <div class="config-content">
      <div class="config-rule flex-center"
           v-for="(rule, index) in ccSchemaContent"
           :key="index">
        <label :for="rule.key">{{rule.name}}</label>
        <component :is="setProperComponent(rule.type)"
                   v-on:input-section-box-update="updateSchemaValues"
                   v-on:rule-input-error="$emit('rule-input-error', $event)"
                   v-on:rule-input-error-remove="$emit('rule-input-error-remove', $event)"
                   :rule-action="null"
                   :rule-value="ccSchemaValues[rule.key]"
                   :ref="rule.key"
                   :rule-type="rule.type"
                   :rule-key="rule.key"
                   :active-rule-platform="activePlatform"
                   :rule-content="rule"></component>
      </div>
      <div class="config-rule flex-center vizual-link" v-if="activePlatform === 'retail'">
        <label>{{ $store.getters.translate('admin_visualizationLink') }}</label>
        <div>
          <input ref="vizInput" :value="getVisualizationLink" readonly/>
<!--          <button @click.stop.prevent="copyToClipboard">-->
<!--            <em class="n-i n-i-copy"></em>-->
<!--          </button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputBox from '../layouts/InputBox';
import SelectBox from '../layouts/SelectBox';

export default {
  name: 'ConfigContentBox',
  components: {
    InputBox,
  },
  props: [
    'ccSchemaName',
    'ccSchemaContent',
    'ccSchemaValues',
    'ccSchemaValuesRaw',
    'activePlatform',
  ],
  computed: {
    getVisualizationLink() {
      const domain = `https://${process.env.VUE_APP_VISUALIZATION}.7platform.net`;
      const layout = 'RetailLayout';
      const platform = 'seven';
      const tenantId = this.$store.getters.company.uuid;
      const productId = window.NB.gameUuid;
      const locale = this.$store.getters.language;
      const timeZone = this.$store.getters.timezone;
      return `${domain}/?layout=${layout}&platform=${platform}&tenantId=${tenantId}&productId=${productId}&locale=${locale}&application=retail&timeZone=${timeZone}`;
    },
  },
  methods: {
    setProperComponent(type) {
      let component = null;
      switch (type) {
        case 'enum':
          component = SelectBox;
          break;
        default:
          component = InputBox;
          break;
      }
      return component;
    },
    updateSchemaValues(event) {
      this.$set(this.ccSchemaValues, event.key, event.value);
      this.$emit('check-validate-schema');
    },
    copyToClipboard() {
      const copyText = this.$refs.vizInput.value;
      navigator.clipboard.writeText(copyText);
    },
  },
};
</script>

<style lang="scss" scoped>
  .config-content-box {
    background-color: #e8ecee;
    border-radius: 2px;
    border: solid 1px #d3dadd;
    display: inline-block;
    margin-right: 20px;
    padding: 20px;
    width: 440px;
    .config-title {
      font-family: primary-font-light;
      margin-bottom: 40px;
      &:first-letter {
        text-transform: capitalize;
      }
    }
    .config-rule {
      font-size: 12px;
      height: 36px;
      justify-content: space-between;
      margin-bottom: 10px;
      input {
        height: 36px;
        padding: 6px 12px;
        width: 220px;
      }
      &.vizual-link {
        div {
          display: flex;
          justify-content: space-between;
        }
        //input {
        //  margin-right: 4px;
        //  width: 180px;
        //}
        //button {
        //  background: linear-gradient(to bottom, #2cabfe 0, #009aff 100%);
        //  border-radius: 4px;
        //  color: #fff;
        //  height: 36px;
        //  width: 36px;
        //}
      }
    }
  }
</style>
